/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import Dates from 'utils/Dates'
import {TFunction} from 'i18next'
import {UiStepsNavStep} from 'components/Forms/UiStepsNav'
import {OfferBasicInputs} from 'components/Offers/schemas/offerBasicSchema'
import {CreateOfferStep} from 'components/Offers/enums/CreateOfferStep'
import {Lead} from 'types/entities/Lead'

interface BuildBasicDefaultsParams {
    defaultValues?: Partial<OfferBasicInputs>
    leadId?: number | null
    selectedLead: Lead | null
}

export const buildCreateOfferSteps = (t: TFunction): UiStepsNavStep<CreateOfferStep>[] => [
    {
        id: CreateOfferStep.Details,
        label: t('Details'),
    },
    {
        id: CreateOfferStep.PackageItems,
        label: t('Package items'),
    },
    {
        id: CreateOfferStep.Upsells,
        label: t('Upsells'),
    },
]

export const buildOfferBasicDefaults = ({ defaultValues, leadId, selectedLead }: BuildBasicDefaultsParams) => {
    if (defaultValues) {
        return defaultValues
    }

    if (leadId && selectedLead?.id === leadId) {
        return {
            adults: Number(selectedLead.persons) || 0,
            children: 0,
            date: selectedLead.requested_date ? Dates.ymd(selectedLead.requested_date) : undefined,
            contact_id: selectedLead.contact_id ?? undefined,
        }
    }

    return undefined
}

export const isOfferLeadDefaultsLoading = ({
    leadId,
    defaultValues,
    selectedLead,
}: BuildBasicDefaultsParams) => {
    if (!leadId || defaultValues) {
        return false
    }

    return !selectedLead || selectedLead.id !== leadId
}
